export const environment = {
  production: false,
  CASHBACK_API: 'https://api-dev-cashback.azurewebsites.net/api/v1/',
  ENABLE_DEBUG: false,
};
